<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="12">
          <a-col :md="6" :sm="8">
            <a-form-item :label="'申请金额（最小）'">
              <a-input :placeholder="$t('enter') + ' 申请金额（最小）'" v-model="queryParam.minApplyAmount"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="'申请金额（最大）'">
              <a-input :placeholder="$t('enter') + ' 申请金额（最大）'" v-model="queryParam.maxApplyAmount"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="'借款次数'">
              <a-input :placeholder="$t('enter') + ' 借款次数'" v-model="queryParam.loanCountNum"></a-input>
            </a-form-item>
          </a-col>
          <a-col  :md="6" :sm="8">
            <a-form-item :label="$t(I18N_KEY.REPAYREPORT + 'requestDate')" :labelCol="{span: 6}" :wrapperCol="{span: 14, offset: 1}">
              <a-range-picker
                v-model="queryParam.examineDate"
                format="YYYY-MM-DD" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="'产品类型'">
              <a-select
                mode="multiple"
                v-model="queryParam.appssids"
              >
                <a-select-option v-for="item in appList" :key="item.appssid">
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="$t('order.applicationDeadline')">
              <a-select mode='multiple'
                        v-model='queryParam.deadlineConfigValues'
              >
                <a-select-option v-for='item in deadlineConfigList' :key='item.itemValue'>
                  {{ item.itemText }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="'订单类型'">
              <a-select default-value="" style="width: 120px" v-model="queryParam.orderType">
                <a-select-option value="">
                  全部
                </a-select-option>
                <a-select-option value="1">
                  展期订单
                </a-select-option>
                <a-select-option value="0">
                  正常订单
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="3" :sm="4">
            <a-form-item :label="'费率'">
              <a-input :placeholder="$t('enter') + ' 费率'" v-model="queryParam.serviceFee"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="'产品类型'">
              <a-select default-value="" style="width: 120px" v-model="queryParam.productType">
                <a-select-option value="">
                  全部
                </a-select-option>
                <a-select-option value="1">
                  主包产品
                </a-select-option>
                <a-select-option value="2">
                  多贷产品
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <a-form-item label="前收后收">
              <a-select default-value="" style="width: 120px" v-model="queryParam.receiptTimeFlag">
                <a-select-option value="">
                  全部
                </a-select-option>
                <a-select-option value="0">
                  前收
                </a-select-option>
                <a-select-option value="1">
                  后收
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='6'>
            <a-form-item label="运营类型">
              <a-select default-value="" style="width: 120px" v-model="queryParam.proxyFlag">
                <a-select-option value="">
                  全部
                </a-select-option>
                <a-select-option value="0">
                  自运营
                </a-select-option>
                <a-select-option value="1">
                  代理运营
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery('', '')" icon="search" style="margin-left: 8px">{{ $t('search') }}</a-button>
              <a-button type="primary" @click="searchQuery('00', '')" icon="search" style="margin-left: 8px">首贷</a-button>
              <a-button type="primary" @click="searchQuery('01', '')" icon="search" style="margin-left: 8px">复贷</a-button>

              <!--               <a-button type="primary" @click="searchQuery('', '0')" icon="search" style="margin-left: 8px">正常订单</a-button>-->
              <!--              <a-button type="primary" @click="searchQuery('', '1')" icon="search" style="margin-left: 8px">展期订单</a-button>-->

              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('reset') }}</a-button>
              <a-button type="primary" @click="downLoadData" icon="download" style="margin-left: 8px">{{ $t('exportFile') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :rowClassName="rowClassName"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        :scroll="{ x: 1500}"
        bordered
        @change="handleTableChange">
        <Dict slot="approvalStatus" slot-scope="text" :dict-code="DICT_CODE.ORDER_STATUS">{{ text }}</Dict>
        <div slot="firstOverDueRate" slot-scope="text,record,index">
          {{text}}
          <a-icon  type="arrow-up" style="color: red;" v-if="index < dataSource.length - 1 && new Date(record['curDate']).getTime() <= new Date(currentDate).getTime() - 1000 * 60 *60 * 24 && Number(text.replace('%','')) > Number(dataSource[index+1]['firstOverDueRate'].replace('%',''))" />
          <a-icon type="arrow-down" style="color: green;" v-if="index < dataSource.length - 1 && new Date(record['curDate']).getTime() <= new Date(currentDate).getTime() - 1000 * 60 *60 * 24 && Number(text.replace('%','')) < Number(dataSource[index+1]['firstOverDueRate'].replace('%',''))" />
        </div>
        <div slot="aoverDueRate" slot-scope="text,record,index">
          {{text}}
          <a-icon  type="arrow-up" style="color: red;" v-if="index < dataSource.length - 1 && new Date(record['curDate']).getTime() <= new Date(currentDate).getTime() - 4 * 1000 * 60 *60 * 24 && Number(text.replace('%','')) > Number(dataSource[index+1]['aoverDueRate'].replace('%',''))" />
          <a-icon type="arrow-down" style="color: green;" v-if="index < dataSource.length - 1 && new Date(record['curDate']).getTime() <= new Date(currentDate).getTime() - 4 * 1000 * 60 *60 * 24 && Number(text.replace('%','')) < Number(dataSource[index+1]['aoverDueRate'].replace('%',''))" />
        </div>
        <div slot="firstAmountOverDueRate" :style="new Date(record['curDate']).getTime() <= new Date(currentDate).getTime() - 1000 * 60 *60 * 24 && Number(text.replace('%','')) > Number(record['firstOverDueRate'].replace('%','')) ? {'background':'orange'}:{}" slot-scope="text,record,index">
          {{text}}
          <a-icon  type="arrow-up" style="color: red;" v-if="index < dataSource.length - 1 && new Date(record['curDate']).getTime() <= new Date(currentDate).getTime() - 1000 * 60 *60 * 24 && Number(text.replace('%','')) > Number(dataSource[index+1]['firstAmountOverDueRate'].replace('%',''))" />
          <a-icon type="arrow-down" style="color: green;" v-if="index < dataSource.length - 1 && new Date(record['curDate']).getTime() <= new Date(currentDate).getTime() - 1000 * 60 *60 * 24 && Number(text.replace('%','')) < Number(dataSource[index+1]['firstAmountOverDueRate'].replace('%',''))" />
        </div>
        <div slot="aAmountoverDueRate" slot-scope="text,record,index">
          {{text}}
          <a-icon  type="arrow-up" style="color: red;" v-if="index < dataSource.length - 1 && new Date(record['curDate']).getTime() <= new Date(currentDate).getTime() - 4 * 1000 * 60 *60 * 24 && Number(text.replace('%','')) > Number(dataSource[index+1]['aAmountoverDueRate'].replace('%',''))" />
          <a-icon type="arrow-down" style="color: green;" v-if="index < dataSource.length - 1 && new Date(record['curDate']).getTime() <= new Date(currentDate).getTime() - 4 * 1000 * 60 *60 * 24 && Number(text.replace('%','')) < Number(dataSource[index+1]['aAmountoverDueRate'].replace('%',''))" />
        </div>
      </a-table>

    </div>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import {getApplist, getRepaymentReportForBeginDate} from '@/webpublicapi/order'
import { getAllDeadlineConfig } from '@/webpublicapi/deadlineConfig'
import exportFile from '@/webpublicapi/exportFile'
import Dict from '../modules/Dict';
import DictSelect from '../modules/DictSelect';
import moment from 'moment'
const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  APPROVAL: 'approval.',
  REPAYREPORT: 'repayReport.',
}
export default {
  name: 'repayReport',
  components: {
    Dict,
    DictSelect,
  },
  data () {
    return {
      I18N_KEY,
      toggleSearchStatus:false,
      visible: false,
      exportParams: '',
      // 分页参数
      form: {
        pageNum: 1,
        pageSize: 10,
      },
      currentDate: 0,
      total: 0,
      appList: [],
      dataSource: [],
      deadlineConfigList: [],
      // 查询条件
      queryParam: {
        'receiptTimeFlag':'',
        "examinerName":"",
        "appssid":"",
        "appssids":undefined,
        "duration":"",
        "deadlineConfigValues": undefined,
        "examineDate":undefined,
      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns () {
      return [
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'curDate'),
          align: 'left',
          fixed: 'left',
          width: 100,
          dataIndex: 'curDate'
        },
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'repayCurCount'),
          align: 'left',
          dataIndex: 'repayCurCount'
        },
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'preCount'),
          align: 'left',
          dataIndex: 'preCount'
        },
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'repayNormalCount'),
          align: 'left',
          dataIndex: 'repayNormalCount'
        },
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'extendCount'),
          align: 'left',
          dataIndex: 'extendCount'
        },
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'repayOverCount'),
          align: 'left',
          dataIndex: 'repayOverCount'
        },
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'overExtendCount'),
          align: 'left',
          dataIndex: 'overExtendCount'
        },
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'overCount'),
          align: 'left',
          dataIndex: 'overCount'
        },
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'firstOverDueRate'),
          align: 'left',
          dataIndex: 'firstOverDueRate',
          width: '100px',
          scopedSlots: { customRender: 'firstOverDueRate' }
        },
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'aoverDueRate'),
          align: 'left',
          dataIndex: 'aoverDueRate',
          width: '100px',
          scopedSlots: { customRender: 'aoverDueRate' }
        },
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'firstAmountOverDueRate'),
          align: 'left',
          dataIndex: 'firstAmountOverDueRate',
          width: '100px',
          scopedSlots: { customRender: 'firstAmountOverDueRate' },
          customCell: (record, rowIndex) => (new Date(record['curDate']).getTime() <= new Date(this.currentDate).getTime() - 1000 * 60 * 60 * 24 && Number(record['firstAmountOverDueRate'].replace('%', '')) > Number(record['firstOverDueRate'].replace('%', '')) ? {
            style: {
              background: 'orange!important'
            }
          } : {})
        },
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'aAmountoverDueRate'),
          align: 'left',
          dataIndex: 'aAmountoverDueRate',
          width: '100px',
          scopedSlots: { customRender: 'aAmountoverDueRate' }
        },
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'perRepayRate'),
          align: 'left',
          width: 80,
          dataIndex: 'perRepayRate'
        },
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'repayNormalRate'),
          align: 'left',
          width: 80,
          dataIndex: 'repayNormalRate'
        },
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'extendCountRate'),
          align: 'left',
          width: 80,
          dataIndex: 'extendCountRate'
        },
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'repayOverCountRate'),
          align: 'left',
          width: 80,
          dataIndex: 'repayOverCountRate'
        },
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'overExtendCountRate'),
          align: 'left',
          width: 80,
          dataIndex: 'overExtendCountRate'
        },
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'OverdueOrderRepaymentRate'),
          align: 'left',
          width: 80,
          dataIndex: 'colbackRate'
        }
      ]
    }
  },
  created () {
    this.loadData(1, '', '');
    getApplist().then(res => {
      this.appList = res.data || [];
    });
    getAllDeadlineConfig().then(res => {
      this.deadlineConfigList = res.data || [];
    });
  },
  methods: {
    handleToggleSearch(){
      this.toggleSearchStatus = !this.toggleSearchStatus;
    },
    searchQuery (arg, arg2) {

      this.loadData(1, arg, arg2)
    },
    loadData (arg,arg2,arg3) {
      // 加载数据 若传入参数1则加载第一页的内容
      console.log(arg2)
      if (arg === 1) {
        this.form.pageNum = 1
      }
      this.loading = true
      var params = this.getQueryParams(arg2, arg3)// 查询条件
      this.exportParams = Object.entries(params).map(([key, value]) => key + '=' + value);
      getRepaymentReportForBeginDate(Object.assign({}, params)).then((res)=>{
        var d = new Date() //创建一个Date对象
        this.currentDate = moment((d.getTime() + d.getTimezoneOffset() * 60000) + (3600000 * -5)).format('YYYY-MM-DD')
        if(res.code===1000){
          // this.total = res.data && res.data.total
          this.dataSource = res.data || [];
        }else{
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false;
        this.$message.error(e.message);
      })
    },
    handleAppssids(params) {
      var appssidsValue = params['appssids'];
      if(appssidsValue != null && appssidsValue != '' && appssidsValue != undefined && appssidsValue.length > 0) {
        var apps = appssidsValue[0];
        for(var item in appssidsValue) {
          if(item != '0') {
            apps = apps + '_' + appssidsValue[item];
          }
        }
        params['appssids'] = apps;
      }
      return params;
    },
    handleDeadlineConfigValues(params) {
      var deadlineConfigValues = params['deadlineConfigValues'];
      if(deadlineConfigValues != null && deadlineConfigValues != '' && deadlineConfigValues != undefined && deadlineConfigValues.length > 0) {
        var deadlines = deadlineConfigValues[0];
        for(var item in deadlineConfigValues) {
          if(item != '0') {
            deadlines = deadlines + '_' + deadlineConfigValues[item];
          }
        }
        params['deadlineConfigValues'] = deadlines;
      }
      return params;
    },
    downLoadData () {
      var params = this.getQueryParams()// 查询条件
      params = this.handleAppssids(params);
      params = this.handleDeadlineConfigValues(params);
      this.exportParams = Object.entries(params).map(([key, value]) => key + '=' + value) + '';
      const file = {
        fileUrl: '/api/web/webpublic/statistics/platform/repaymentReportForBeginDateExcel?' + this.exportParams.replaceAll(",", "&"),
        fileName: 'report.xls',
      }
      this.loading = true;
      exportFile(file).catch(e => {
        this.$message.error(e.message);
      }).finally(() => {
        this.loading = false;
      })
    },
    transformTime (time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow (str) {
      return str && str.toLocaleLowerCase();
    },
    getQueryParams (arg, arg3) {
      const { examineDate } = this.queryParam;
      const data = {
        ...this.queryParam,
        startDate: examineDate && this.transformTime(examineDate[0]),
        endDate: examineDate && this.transformTime(examineDate[1]),
        loanCount: arg,
        // orderType: arg3,
      }
      delete data.examineDate;
      return filterObj(data)
    },
    handleTableChange (pageNum, pageSize) {
      this.form.pageNum = pageNum;
      this.form.pageSize = pageSize;
      this.loadData();
    },
    // 重置字典类型搜索框的内容
    searchReset () {
      var that = this
      that.queryParam.examinerName = ''
      that.queryParam.examineDate = undefined;
      that.queryParam.receiptTimeFlag = ''
      that.loadData(this.form.pageNum)
    },
    rowClassName(record,index){
      var date = new Date(record.curDate);
      var day = date.getTime() / 24 / 60 / 60 / 1000 + 3;
      console.log(record.curDate , date, (day % 7) + 1);

      if((day % 7) + 1 == 7){
        return 'table_weekendColor';
      }
      return '';
    }
  }
}
</script>

<style lang="less" scoped>
@import "~@/assets/less/common.less";

</style>
